import { Controller } from '@hotwired/stimulus'

const _randomColor = (): string => {
  const color = Math.floor(Math.random() * 16777215).toString(16)
  if (color.length < 6) {
    return _randomColor()
  }
  return color
}

export default class extends Controller<HTMLDivElement> {
  static targets = ['input']

  declare readonly inputTarget: HTMLInputElement

  _pickRandomColorForInput(): void {
    const color = _randomColor().toUpperCase()
    this.inputTarget.value = color
    this.inputTarget.dispatchEvent(new InputEvent('input'))
  }

  connect(): void {
    this._pickRandomColorForInput()
  }

  randomiserClicked(): void {
    this._pickRandomColorForInput()
  }
}
